'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConsignmentRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsignmentRemote = exports.ConsignmentRemote = {
    postConsignment: function postConsignment(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            file = _ref.file,
            form = _ref.form,
            userData = _ref.userData;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/consignment/upload', deployment);
            var address = '' + userData.address + (userData.address2 ? '' + (' ' + userData.address2) : '');
            (0, _helpers.addAuthToken)(request, authToken);
            request.field('address', address).field('city', userData.city).field('country', userData.country).field('description', form.description).field('email', form.email).field('multi2', form.multi2).field('name', userData.firstName + ' ' + userData.lastName).field('other', form.other).field('state', userData.state).field('telephone', userData.mobileNumber).attach('photo', file).end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/consignment.js
// module id = 5jkQ
// module chunks = 46